import React, { useEffect, useState } from "react";
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css'; // Importa il CSS di SunEditor

function EditorDescLungaSUNEDITOR({
    nuovaDesc,
    initialValue,
    value,
    handleChangeEditor
}) {

    /* if (nuovaDesc) {
        return <ReactQuill theme="snow" value={value} onChange={handleChangeEditor} />
    } else {
        return <ReactQuill theme="snow" defaultValue={initialValue} value={value} onChange={handleChangeEditor} />
    } */

    if (nuovaDesc) {
        return(<SunEditor
            setContents={initialValue} // Imposta il contenuto iniziale
            onChange={handleChangeEditor} // Gestisce i cambiamenti
            height="800px" // Altezza editor
            setOptions={{
              buttonList: [
                ['undo', 'redo'],
                ['bold', 'italic', 'underline', 'strike'],
                /* ['fontColor', 'hiliteColor'], */
                ['align', 'list', /* 'indent', 'outdent' */],
                /* ['table', 'link', 'image'], */
              ],
              font: [
                'Arial', 
                'Courier New', 
                'Georgia', 
                'Tahoma', 
                'Times New Roman', 
                'Verdana'
              ],
              defaultStyle: "font-family: 'Roboto', Arial, sans-serif;",
            }} // Configura i pulsanti della toolbar
          />) 
    } else {
        return(<SunEditor
            setContents={value} // Imposta il contenuto iniziale
            onChange={handleChangeEditor} // Gestisce i cambiamenti
            height="800px" // Altezza editor
            setOptions={{
              buttonList: [
                ['undo', 'redo'],
                ['bold', 'italic', 'underline', 'strike'],
                /* ['fontColor', 'hiliteColor'], */
                ['align', 'list', /* 'indent', 'outdent' */],
                /* ['table', 'link', 'image'], */
              ],
              defaultStyle: "font-family: 'Roboto', Arial, sans-serif;",
            }} // Configura i pulsanti della toolbar
          />)
    }
}

export default EditorDescLungaSUNEDITOR;



